import { Card, CardContent } from '../ui/card';

interface TextWidgetProps {
  content: string;
  fontSize?: number;
  textAlign?: 'left' | 'center' | 'right';
}

export default function TextWidget({
  content,
  fontSize = 14,
  textAlign = 'left',
}: TextWidgetProps) {
  return (
    <Card className="h-full flex flex-col">
      <CardContent className="p-6 flex-1">
        <div
          className="prose prose-sm max-w-none text-foreground"
          style={{ fontSize, textAlign }}
        >
          {content}
        </div>
      </CardContent>
    </Card>
  );
}
